import getRouterBasename from '@/lib/router';
import { Navigate, createBrowserRouter } from 'react-router-dom';
type RouterLike = unknown;

import AuthCallback from 'pages/AuthCallback';
import Element from 'pages/Element';
import Env from 'pages/Env';
import Home from 'pages/Home';
import Login from 'pages/Login';
import Thread from 'pages/Thread';
import TeamsTab from 'pages/TeamsTab';
import TeamsAuthStart from 'pages/TeamsAuthStart';
import TeamsAuthEnd from 'pages/TeamsAuthEnd';

export const router: RouterLike = createBrowserRouter(
  [
    {
      path: '/',
      element: <Home />
    },
    {
      path: '/env',
      element: <Env />
    },
    {
      path: '/thread/:id?',
      element: <Thread />
    },
    {
      path: '/element/:id',
      element: <Element />
    },
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/login/callback',
      element: <AuthCallback />
    },
    {
      path: '/auth/oauth/azure-ad/callback',
      element: <AuthCallback />
    },
    {
      path: '/teams-tab',
      element: <TeamsTab />
    },
    {
      path: '/teams-auth-start',
      element: <TeamsAuthStart />
    },
    {
      path: '/teams-auth-end',
      element: <TeamsAuthEnd />
    },
    {
      path: '*',
      element: <Navigate replace to="/" />
    }
  ],
  { basename: getRouterBasename() }
);
